var $ = jQuery.noConflict();

   if($("#create_customer").length > 0){
       var interval_fix = setInterval(() => {
        var errText = $('#create_customer .errors ul li').html();
        if(errText == 'This email address is already associated with an account. If this account is yours, you can &lt;a href="/account/login#recover"&gt;reset your password&lt;/a&gt;'){
          $('#create_customer .errors ul li').html('This email address is already associated with an account. If this account is yours, you can <a href="/account/login#recover">reset your password</a>');
          clearInterval(interval_fix);
        }
    
    },10); 
   }

$(window).on('load', function() {
  
   var interval = setInterval(() => {

        $('.product-card .product-card__info .product-card__name').matchHeight({
          byRow: true,
          property: 'height',
          target: null,
          remove: false
        }).addClass('mht');
    
       if($('.product-card .product-card__info .product-card__name').hasClass('mht')){
           clearInterval(interval);
        }
    
    },300); 


      $('.blog__item .blog__title-link').matchHeight({
          byRow: false,
          property: 'min-height',
          target: null,
          remove: false
        });

        $('.blog__item .blog__content .parafont').matchHeight({
          byRow: false,
          property: 'min-height',
          target: null,
          remove: false
        });
    
});

window.addEventListener('resize', function(event) {
    $('.product-card .product-card__info .product-card__name').matchHeight({
          byRow: true,
          property: 'height',
          target: null,
          remove: false
        });


      $('.blog__item .blog__title-link').matchHeight({
          byRow: false,
          property: 'min-height',
          target: null,
          remove: false
        });

        $('.blog__item .blog__content .parafont').matchHeight({
          byRow: false,
          property: 'min-height',
          target: null,
          remove: false
        });


  
}, true);



$("li.site-nav__item.site-nav__item-mega").on({

    mouseenter: function () {
      if($(".site-header").hasClass('active')){
       $(".site-header").addClass('allready'); 
      }else{
        $(".site-header").addClass('active'); 
      }
    },
    mouseleave: function () {
    if($(".site-header").hasClass('allready')){
        $(".site-header").removeClass('allready'); 
    }else{
      $(".site-header").removeClass('active'); 
    }
    }

});